<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_42553_186281" fill="white">
      <rect x="2.75" y="2.75" width="4.66655" height="4.66655" rx="0.583318" />
    </mask>
    <rect x="2.75" y="2.75" width="4.66655" height="4.66655" rx="0.583318" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" mask="url(#path-1-inside-1_42553_186281)" />
    <mask id="path-2-inside-2_42553_186281" fill="white">
      <rect x="8.58203" y="2.75" width="4.66655" height="4.66655" rx="0.583318" />
    </mask>
    <rect x="8.58203" y="2.75" width="4.66655" height="4.66655" rx="0.583318" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" mask="url(#path-2-inside-2_42553_186281)" />
    <mask id="path-3-inside-3_42553_186281" fill="white">
      <rect x="2.75" y="8.58301" width="4.66655" height="4.66655" rx="0.583318" />
    </mask>
    <rect x="2.75" y="8.58301" width="4.66655" height="4.66655" rx="0.583318" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" mask="url(#path-3-inside-3_42553_186281)" />
    <path d="M9.16406 10.916H12.664M10.914 12.6659L10.914 9.16602" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
